<template>

    <button 
        class="woocommerce-button button ad_button"
        :class="{ 'ad_button--loading' : loading }"
        :disabled="loading"
     >

        <slot></slot>

    </button>    

</template>

<script>

export default {

    props: {
        loading: {
            default: false
        }
    }
}

</script>

<style scoped>

.ad_button {
    position: relative;
    cursor: pointer;
}

.ad_button.ad_button--loading {
    color: transparent !important;
}

.ad_button.ad_button--loading::after {
    box-sizing: border-box;
    content: "";
    position: absolute;
    width: 24px;
    height: 24px;
    top: calc(50% - 12px);
    left: calc(50% - 12px);
    border: 4px solid transparent;
    border-top-color: rgba(255, 255, 255, 1);
    border-radius: 50%;
    animation: button-loading-spinner 1s ease infinite;
}

@keyframes button-loading-spinner {
    from {
        transform: rotate(0turn);
    }

    to {
        transform: rotate(1turn);
    }
}


</style>